import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SettingsService } from '@services/settings.service';

import '@core/extension';
import { SynchronizationService } from '@core/services/synchronization.service';
import { Multilingual } from '@core/utilities/multilingual';
import { MultilingualService } from '@core/services/multilingual.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {

  public get ready(): boolean {
    return this.sync.ready(MultilingualService);
  }
  constructor(
    private settings: SettingsService,
    private title: Title,
    private sync: SynchronizationService,
    private lang: MultilingualService
  ) {
    this.title.setTitle(Multilingual.getText(this.settings.app.name));
  }

  ngOnInit() {
    if (location.protocol == "http:" && location.hostname != 'localhost') location.protocol = "https:"
  }
}
